const configErrors = {
  'trainingSession.endTime': {
    endTime: 'errors.endTimeBeforeStartTime',
  },
  'trainingSession.startTime': {
    startTime: 'trainingSession.startTimeRequired',
  },
  'trainingSession.endDate': {
    endDate: 'errors.endDateBeforeStartDate',
  },
  'trainingSession.startDate': {
    startDate: 'trainingSession.startDateRequired',
  },
  'trainingSession.maxStudents': {
    maxStudents: 'trainingSession.maxStudentsRequired',
  },
  'trainingSession.maxStudentsRequired': {
    maxStudents: 'trainingSession.maxStudentsRequired',
  },
  'trainingSession.invalidDeliveryMethod': {
    deliveryMethod: 'trainingSession.invalidDeliveryMethod',
  },
  'trainingSession.moodleLinksRequired': {
    deliveryMethod: 'trainingSession.moodleLinksRequired',
  },
  'trainingSession.moodleLanguageMissingForStation': {
    deliveryMethod: 'trainingSession.moodleLanguageMissingForStation',
  },
  'trainingSession.moodleLanguagesIncompleteForGlobal': {
    deliveryMethod: 'trainingSession.moodleLanguagesIncompleteForGlobal',
  },
  'trainingSession.deliveryMethod': {
    deliveryMethod: 'trainingSession.deliveryMethodRequired',
  },
  'trainingSession.trainingModule': {
    trainingModule: 'trainingSession.trainingModuleRequired',
  },
  'trainingSession.trainingPart': {
    trainingPart: 'trainingSession.trainingPartRequired',
  },
  'trainingSession.endTimeRequired': {
    endTime: 'trainingSession.endTimeRequired',
  },
  'trainingSession.trainerNotFound': {
    trainer: 'trainingSession.trainerNotFound',
  },
  'trainingSession.trainerNotAssigned': {
    trainer: 'trainingSession.trainerNotAssigned',
  },
  'trainingSession.startDateLockedAfterLaunch': {
    startDate: 'trainingSession.startDateLockedAfterLaunch',
  },
  'trainingSession.startBeforePartAvailable': {
    startDate: 'trainingSession.startBeforePartAvailable',
  },
  'trainingSession.startAfterPartAvailable': {
    startDate: 'trainingSession.startAfterPartAvailable',
  },
  'trainingSession.endBeforePartAvailable': {
    endDate: 'trainingSession.endBeforePartAvailable',
  },
  'trainingSession.endAfterPartAvailable': {
    endDate: 'trainingSession.endAfterPartAvailable',
  },
  'trainingSession.endAfterAllowedMax': {
    endDate: 'trainingSession.endAfterAllowedMax',
  },
  'trainingSession.trainingPartNotLaunched': {
    trainingPart: 'trainingSession.trainingPartNotLaunched',
  },
  'trainingPart.disabledForCompany': {
    trainingPart: 'trainingPart.disabledForCompany',
  },
  'trainingModule.notFound': {
    trainingModule: 'trainingModule.notFound',
  },
  'trainingPart.notFound': {
    trainingPart: 'trainingPart.notFound',
  },
  'station.notFound': {
    station: 'station.notFound',
  },
  'station.forbidden': {
    station: 'station.forbidden',
  },
  'trainingSession.station': {
    station: 'trainingSession.stationRequired',
  },
};

export default configErrors;
